<script>
import { gmapApi } from "vue2-google-maps";
export default {
  data() {
    return {
      infoWinOpen: false
    };
  },
  computed: {
    google: gmapApi,
    dialog: {
      get() {
        return this.$store.state.messagingLog.dialog;
      },
      set(val) {
        this.$store.commit("messagingLog/updateDialog", val);
      }
    },
    selected() {
      return this.$store.state.messagingLog.selected;
    }
  }
};
</script>

<template>
  <div>
    <v-dialog max-width="600" v-model="dialog">
      <v-card>
        <v-card-text class="pa-4">
          <GmapMap
            ref="googleMap"
            :center="selected.coordinate"
            :zoom="15"
            :style="`width: 100%; height: 400px;`"
            :options="{
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: true,
              streetViewControl: false,
              rotateControl: true,
              fullscreenControl: true,
              disableDefaultUI: true
            }"
            id="satcom_message-location__google-map"
          >
            <GmapMarker
              :position="selected.coordinate"
              :icon="require(`@/assets/icons/marker-green.svg`)"
              id="satcom_message-location__marker"
              @click="infoWinOpen = true"
            >
            </GmapMarker>
            <GmapInfoWindow
              :opened="infoWinOpen"
              :position="selected.coordinate"
              :options="{
                pixelOffset: {
                  width: 0,
                  height: -35
                }
              }"
              id="satcom_message-location__info"
              @closeclick="infoWinOpen = false"
            >
              <div class="font-weight-bold">
                {{ $t("modules.logs.messagingLog.deviceName") }}:
                {{ selected.device_name }}
              </div>
              <div class="font-weight-bold">
                {{ $t("modules.logs.messagingLog.altitude") }}:
                {{ selected.altitude }} m
              </div>
            </GmapInfoWindow>
          </GmapMap>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            {{ $t("actions.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
